var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5135 12.6643C27.5135 10.4593 27.5135 0.5 27.5135 0.5H25.5498H24.3877H22.424C22.424 0.5 22.424 10.4593 22.424 12.6643C22.424 14.8693 17.4449 17.5459 17.4449 20.688C17.4449 23.8301 17.4449 46.56 17.4449 47.3624C17.4449 48.1647 18.0921 49.5 19.5336 49.5C20.5191 49.5 22.9389 49.5 24.3951 49.5C25.0864 49.5 25.5571 49.5 25.5571 49.5C27.0134 49.5 29.4331 49.5 30.4113 49.5C31.8528 49.5 32.5 48.1647 32.5 47.3624C32.5 46.56 32.5 23.8301 32.5 20.688C32.4926 17.5459 27.5135 14.8693 27.5135 12.6643ZM30.5584 41.121C30.5584 41.5865 30.1024 41.9663 29.5434 41.9663H20.3868C19.8278 41.9663 19.3718 41.5865 19.3718 41.121V25.8452C19.3718 25.3797 19.8278 25 20.3868 25H29.5434C30.1024 25 30.5584 25.3797 30.5584 25.8452V41.121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranWine);
export default __webpack_public_path__ + "static/media/branWine.4346efa0a5ae8bdffd881e64695f38db.svg";
export { ForwardRef as ReactComponent };